import { render, staticRenderFns } from "./WizardViewStrategy.vue?vue&type=template&id=50a9bd05&"
import script from "./WizardViewStrategy.vue?vue&type=script&lang=js&"
export * from "./WizardViewStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports